import { useDispatch, useSelector } from "react-redux";
import { Transaction } from "../components/Transaction";
import { fetchPaginationTransactions } from "./../features/transaction/transactionSlice";
import { useEffect } from "react";
import { Form } from "./../components/Form";
import { Pagination } from "./../components/Pagination";
import { useNavigate } from "react-router-dom";
import { Filter } from "./../components/Filter";

export const TransectionList = () => {
    const dispatch = useDispatch();
    const { transactions, transaction, isLoading, isError } = useSelector(
        (state) => state.transaction
    );
    const pagination = useSelector((state) => state.pagination) || {};
    const { type, find } = useSelector((state) => state.filter) || {};

    const navigation = useNavigate();
    const { currentPage, limit } = pagination.pagination;

    useEffect(() => {
        dispatch(
            fetchPaginationTransactions({ currentPage, limit, type, find })
        );
    }, [dispatch, pagination.pagination, type, find, currentPage, limit]);

    let content = null;

    if (isLoading)
        content = <p className="text-sm text-green-600 py-4">Loading...</p>;

    if (!isLoading && isError)
        content = (
            <p className="text-red-600 text-sm py-4">
                There was an error occured
            </p>
        );

    if (!isLoading && !isError && transactions?.length > 0) {
        content = transactions.map((transaction) => {
            return (
                <Transaction key={transaction.id} transaction={transaction} />
            );
        });
    }
    if (!isLoading && !isError && transactions?.length === 0)
        content = (
            <p className="text-red-600 text-sm py-4">
                There have not transactions
            </p>
        );

    const backHandler = () => {
        navigation("/", { replace: true });
    };

    return (
        <>
            <div className="md:w-4/12 mx-auto mt-6">
                <button
                    onClick={backHandler}
                    className="px-4 text-sm py-1 inline-block bg-green-200 text-green-600 rounded mb-3"
                >
                    Back
                </button>
            </div>
            {transaction?.id && <Form />}
            <div className="md:w-4/12 mx-auto mt-6">
                <Filter />
            </div>
            <div className="md:w-4/12 mx-auto mt-6">{content}</div>
            {!pagination.isLoading && !pagination.isError && (
                <Pagination pagination={pagination.pagination} />
            )}
        </>
    );
};
